'use client';

function isAbsolutePositioning(element) {
    var position = window.getComputedStyle(element).position;
    return position === 'absolute';
}

export { isAbsolutePositioning as default };
//# sourceMappingURL=isAbsolutePositioning.js.map
